module.exports = __webpack_public_path__ + "img/role-p-4.4f14650c.png";